export default "__VITE_ASSET__DFAiQHZM__"